export const ZFP_API_URL_DEFAULT = "https://analyzer-api.dev3.zfpa.cz";
// export const ZFP_API_URL_DEFAULT = "http://localhost:10003";
export const ADMIN_URL_DEFAULT = "https://admin.staging.zfpa.cz";

export const STALE_TIME_5_MIN = 5 * 60 * 1000;
export const ANALYZER_EMAIL = "analyzator@zfpa.cz";
